export default __webpack_public_path__ + "static/media/thumbnail.0a1c5c4f.webp";